const getMapLink = (query) => {
  if (
    typeof navigator !== 'undefined' &&
    (navigator.platform.indexOf('iPhone') !== -1 ||
      navigator.platform.indexOf('iPad') !== -1 ||
      navigator.platform.indexOf('iPod') !== -1)
  ) {
    return `maps://maps.google.com/maps?q=${query}`;
  } else {
    return `https://maps.google.com/maps?q=${query}`;
  }
};

export const getSalesCenterAddress = (salesCenterData = {}) => {
  const salesCenter = salesCenterData || {};
  const streetAddress = [
    salesCenter.address1 || salesCenter.firstAddress,
    salesCenter.address2 || salesCenter.secondAddress,
  ]
    .filter(Boolean)
    .join(' ');
  const cityStateZip = [
    salesCenter.city,
    salesCenter.stateAbbreviation,
    salesCenter.zipcode,
  ]
    .filter(Boolean)
    .join(' ');

  return [streetAddress, cityStateZip].filter(Boolean).join(', ');
};

export const getSalesCenterMapHref = (salesCenterData = {}) => {
  const salesCenter = salesCenterData || {};
  if (salesCenter.gmbLink && salesCenter.gmbLink.href) {
    return salesCenter.gmbLink.href;
  }

  if (salesCenter.latitude && salesCenter.longitude) {
    return getMapLink(`${salesCenter.latitude},${salesCenter.longitude}`);
  }

  return getMapLink(getSalesCenterAddress(salesCenter));
};

export default getMapLink;
